<template>
  <WebChapterTemplate
    page-title="舆情调查"
    section-label="学科建设"
    :section-route="sectionRoute"
    :top-strip-image="topStripImage"
    :hero-background-image="heroBackgroundImage"
  >
    <div class="opinion-manual">
      <section class="opinion-section">
        <div class="opinion-section__header">
          <h2 class="opinion-section__title">中国舆情调查实验室</h2>
          <p class="opinion-section__summary">
            围绕舆情监测、调查系统发布和新媒体数据研究，新闻与传播研究所持续推进实验室平台建设。
          </p>
        </div>

        <article class="opinion-feature">
          <div class="opinion-feature__media">
            <figure class="opinion-figure">
              <img
                :src="require('./assets/html/opinionlab-2013-establish.jpg')"
                alt="2013 年中国舆情调查实验室揭牌成立"
                loading="lazy"
              />
            </figure>
          </div>
          <div class="opinion-feature__body">
            <h3 class="opinion-card__title">2013 年实验室揭牌成立</h3>
            <p class="opinion-card__text">
              2013 年 2 月，中国社会科学院中国舆情调查实验室在新闻与传播研究所揭牌成立。
            </p>
          </div>
        </article>

        <div class="opinion-grid opinion-grid--2">
          <article class="opinion-card">
            <figure class="opinion-figure">
              <img
                :src="require('./assets/html/opinionlab-2013-release.jpg')"
                alt="2013 年舆情调查系统推介暨首次调查成果发布会"
                loading="lazy"
              />
            </figure>
            <div class="opinion-card__body">
              <h3 class="opinion-card__title">2013 年调查成果发布会</h3>
              <p class="opinion-card__text">
                2013 年 5 月，中国舆情调查实验室和中国社会科学院调查与数据信息中心联合主办的“中国社会科学院中国舆情调查实验室‘舆情调查系统’推介暨首次调查成果发布会”在北京举行。
              </p>
            </div>
          </article>

          <article class="opinion-card">
            <figure class="opinion-figure">
              <img
                :src="require('./assets/html/opinionlab-2016-salon.jpg')"
                alt="2016 年第一次新媒体与大数据沙龙"
                loading="lazy"
              />
            </figure>
            <div class="opinion-card__body">
              <h3 class="opinion-card__title">2016 年新媒体与大数据沙龙</h3>
              <p class="opinion-card__text">
                2016 年 3 月，第一次新媒体与大数据沙龙在新闻与传播研究所举行。
              </p>
            </div>
          </article>
        </div>
      </section>

      <section class="opinion-section">
        <div class="opinion-section__header">
          <h2 class="opinion-section__title">舆情研究平台拓展</h2>
          <p class="opinion-section__summary">
            2017 年后，实验室与国家治理研究智库、出版社及媒体平台持续扩展合作。
          </p>
        </div>

        <article class="opinion-feature opinion-feature--reverse">
          <div class="opinion-feature__media">
            <figure class="opinion-figure">
              <img
                :src="require('./assets/html/opinionlab-2017-plaque.jpg')"
                alt="2017 年国家治理研究智库舆情研究部挂牌仪式"
                loading="lazy"
              />
            </figure>
          </div>
          <div class="opinion-feature__body">
            <h3 class="opinion-card__title">2017 年挂牌仪式</h3>
            <p class="opinion-card__text">
              2017 年 3 月，中国社会科学院国家治理研究智库舆情研究部举行挂牌仪式，副院长李培林出席。
            </p>
          </div>
        </article>

        <div class="opinion-grid opinion-grid--2">
          <article class="opinion-card">
            <figure class="opinion-figure">
              <img
                :src="require('./assets/html/opinionlab-2018-report.jpg')"
                alt="2018 年宜居中国发展指数报告发布"
                loading="lazy"
              />
            </figure>
            <div class="opinion-card__body">
              <h3 class="opinion-card__title">2018 年报告发布</h3>
              <p class="opinion-card__text">
                2018 年 1 月，新闻与传播研究所编制的《宜居中国发展指数报告（2017-2018）》在中国社会科学出版社正式发布。
              </p>
            </div>
          </article>

          <article class="opinion-card">
            <figure class="opinion-figure">
              <img
                :src="require('./assets/html/opinionlab-2018-workshop.jpg')"
                alt="2018 年微聚正能量研讨会"
                loading="lazy"
              />
            </figure>
            <div class="opinion-card__body">
              <h3 class="opinion-card__title">2018 年正能量传播研讨会</h3>
              <p class="opinion-card__text">
                2018 年 5 月，舆情调查实验室与中国社会科学网联合举办“微聚正能量·新媒体正能量传播”研讨会。
              </p>
            </div>
          </article>
        </div>
      </section>
    </div>
  </WebChapterTemplate>
</template>

<script>
import WebChapterTemplate from '@/components/WebChapterTemplate.vue';

export default {
  name: 'LanhuYuqingdiaocha',
  components: {
    WebChapterTemplate
  },
  data() {
    return {
      sectionRoute: '/lanhu_xuekeyukeyan',
      topStripImage: require('@/views/lanhu_jigouyulishi/assets/img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.png'),
      heroBackgroundImage: require('@/views/lanhu_zhengwenyexueshuchengguo/assets/img/173301bb9c6d42d7ae3028c182487260_mergeImage.png')
    };
  }
};
</script>

<style scoped>
.opinion-manual {
  display: grid;
  gap: 32px;
}

.opinion-section {
  padding: 26px;
  border-radius: 12px;
  border: 1px solid rgba(179, 145, 101, 0.18);
  background:
    linear-gradient(140deg, rgba(248, 242, 233, 0.84), rgba(255, 255, 255, 0) 42%),
    linear-gradient(180deg, #fff, rgba(253, 250, 246, 0.96));
  box-shadow: 0 14px 30px rgba(59, 41, 17, 0.05);
}

.opinion-section__header {
  margin-bottom: 24px;
  padding-bottom: 14px;
  border-bottom: 1px solid rgba(179, 145, 101, 0.16);
}

.opinion-section__title {
  margin: 0;
  color: #f25c19;
  font-size: 26px;
  line-height: 1.4;
  font-family: 'Songti SC', 'STSong', 'Noto Serif SC', serif;
  font-weight: 700;
}

.opinion-section__summary {
  margin: 10px 0 0;
  color: #6b5b4b;
  font-size: 16px;
  line-height: 1.8;
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

.opinion-feature {
  display: grid;
  grid-template-columns: minmax(0, 1.35fr) minmax(260px, 0.9fr);
  gap: 20px;
  align-items: center;
  margin-bottom: 28px;
}

.opinion-feature--reverse {
  grid-template-columns: minmax(260px, 0.9fr) minmax(0, 1.35fr);
}

.opinion-feature__media,
.opinion-card {
  overflow: hidden;
  border-radius: 12px;
  border: 1px solid rgba(179, 145, 101, 0.16);
  background: #fff;
  box-shadow: 0 10px 24px rgba(45, 33, 16, 0.05);
}

.opinion-feature__body {
  display: grid;
  gap: 10px;
}

.opinion-grid {
  display: grid;
  gap: 20px;
}

.opinion-grid--2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.opinion-figure {
  margin: 0;
  background: #f8f4ee;
}

.opinion-figure img {
  display: block;
  width: 100%;
  height: auto;
}

.opinion-card__body {
  padding: 18px 18px 20px;
}

.opinion-card__title {
  margin: 0;
  color: #2f2a25;
  font-size: 20px;
  line-height: 1.5;
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  font-weight: 600;
}

.opinion-card__text {
  margin: 0;
  color: #4c433a;
  font-size: 17px;
  line-height: 1.9;
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

@media (max-width: 1024px) {
  .opinion-feature,
  .opinion-feature--reverse,
  .opinion-grid--2 {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .opinion-section {
    padding: 18px;
  }

  .opinion-section__title {
    font-size: 24px;
  }

  .opinion-card__title {
    font-size: 18px;
  }

  .opinion-card__text,
  .opinion-section__summary {
    font-size: 16px;
    line-height: 1.8;
  }
}
</style>
